.cabecera { display: flex; justify-content: space-between; align-items: flex-start; gap: var(--s-6); margin-bottom: var(--s-6); flex-wrap: wrap; }
.sugerida { margin-top: var(--s-9); padding-top: var(--s-8); border-top: var(--bw-hair) solid var(--border-hair); }
.codigo, .correo {
  margin: 0;
  padding: var(--s-6) var(--s-7);
  border-radius: var(--r-card);
  background: var(--surface-sunken);
  border: var(--bw-hair) solid var(--border-hair);
  font-family: var(--font-mono);
  font-size: var(--fs-2xs);
  line-height: 19px;
  color: var(--gray-700);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.correo { font-family: var(--font-body); font-size: var(--fs-xs); line-height: 20px; }
.pasos { display: flex; flex-direction: column; gap: var(--s-8); }
.paso { display: flex; flex-direction: column; gap: var(--s-4); }
